import { Component, Input } from '@angular/core';

import { SecurityContextService } from 'rev-shared/security/SecurityContext.Service';

import styles from './video-categories.module.less';

@Component({
	selector: 'video-categories',
	templateUrl: './VideoCategories.Component.html'
})
export class VideoCategoriesComponent {
	@Input() public categories: any[];

	public readonly styles = styles;

	constructor(
		private SecurityContext: SecurityContextService,
	) { }

	public get isGuestPortalEnabled(): boolean {
		return this.SecurityContext.checkAuthorization('guest');
	}
}
